import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { brandName } from '../data/copy';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-navy py-14 sm:py-20" aria-labelledby="guarantee-heading" data-id="element-107" data-mp="9ucrn7u79n36">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-108" data-mp="et65509hle3c">
        <Medallion icon={ShieldCheckIcon} data-id="element-109" data-mp="eur0gs3ml129" />

        <p className="mt-6 font-display text-base font-bold uppercase tracking-[0.22em] text-accent" data-id="element-110" data-mp="jssfn1xxkg8g">
          7-day guarantee
        </p>
        <h2 id="guarantee-heading" className="mt-2 font-display text-[2.6rem] font-extrabold uppercase leading-none text-fg sm:text-6xl" data-id="element-111" data-mp="nst4zhmkibua">
          100% protected
        </h2>

        <div className="mx-auto mt-7 max-w-prose space-y-4 text-lg leading-relaxed text-muted" data-id="element-112" data-mp="xk72jjuyl1ks">
          <p data-id="element-113" data-mp="12jtgjvim2lun">
            Access {brandName} and make sure you receive the 6 volumes and 5
            bonuses described on this page.
          </p>
          <p data-id="element-114" data-mp="17g0otuyhc9fr">
            If a file is incomplete, you have an access problem, or the material
            delivered does not match the description of this offer, contact us
            within 7 days.
          </p>
          <p data-id="element-115" data-mp="1vtr94b7h5xwr">We will review the issue and work to solve it.</p>
          <p data-id="element-116" data-mp="1vu9crswgveep">
            If we cannot resolve it, you will receive a{' '}
            <span className="font-semibold text-fg" data-id="element-117" data-mp="1rt7d5ayn10c7">full refund</span>.
          </p>
        </div>
        <p className="mt-8 font-display text-2xl font-extrabold uppercase text-accent" data-id="element-118" data-mp="2oioifotpkkdd">
          Zero unnecessary risk for you.
        </p>
      </div>
    </section>;
}